:host {
  --primary-color: #7263FA;
  --primary-background-color: #FFF;
  --theme-based-radius: 0px;
  --theme-based-padding: 0px;

  /* buttons */
  --button-animation-duration: 200ms;
  --text-color: #000;
  --button-border-color: #B2D4FF;
  --button-border-radius: 9999px;
  --button-background-color: var(--primary-background-color);

  /* modal */
  --modal-logo-border-color: var(--primary-color);
  --modal-animation-duration: 350ms;
  --easing: cubic-bezier(0.16, 1, 0.3, 1);
  --disabled-background-color: rgba(0, 0, 0, 0.12);
  --disabled-color: rgba(0, 0, 0, 0.3);
  /*--easing: ease;*/

  font-family: sans-serif;
}

.dark {
  --button-background-color: rgb(30, 41, 59);
  --primary-background-color: rgb(30, 41, 59);
  --button-border-color: #FFFFF9;
  --text-color: #FFFFF9;
  --modal-logo-border-color: #CCC;
  --disabled-background-color: rgba(255, 255, 255, 0.12);
  --disabled-color: rgba(255, 255, 255, 0.3);
  --theme-based-radius: 4px;
  --theme-based-padding: 8px;
}

.button {
  font-size: 16px;
  color: var(--text-color);
  cursor: pointer;
  padding: 8px 12px 8px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--button-border-color);
  background-color: var(--button-background-color);
  border-radius: var(--button-border-radius);
}

.button:hover {
  transition: box-shadow var(--button-animation-duration);
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  /* lighter shade of --button-background-color */
  background: linear-gradient(
    to top,
    rgba(200, 200, 200, 0.1),
    rgba(200, 200, 200, 0.1)
  ) var(--button-background-color)
}

.button:active {
  transition: box-shadow var(--button-animation-duration);
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
}

.button__logo {
  width: 1.3rem;
}

.disabled {
  background-color: dimgrey;
  color: linen;

  cursor: not-allowed;
  pointer-events: none;
}

/* -------- modal --------- */

.modal {
  display: flex;
  z-index: 9999;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.3);
  transition: opacity var(--modal-animation-duration) var(--easing);
}

.modal--hidden {
  opacity: 0;
  pointer-events: none;
}

.modal__content {
  max-width: 240px;
  border-radius: 4px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  background-color: var(--primary-background-color);
  transform: scale(1);
  transition: transform var(--modal-animation-duration) var(--easing);
}

.modal--hidden .modal__content {
  transform: scale(0.5);
}

.modal__qrcode__container {
  width: 240px;
  box-sizing: border-box;
  position: relative;
  background-color: white;
  border-radius: var(--theme-based-radius);
  padding: var(--theme-based-padding);
}

.modal__qrcode {
  border-radius: 4px;
  width: 100%;
  height: auto;
}

.modal__logo {
  padding: 8px;
  border: 2px var(--modal-logo-border-color) solid;
  border-radius: var(--button-border-radius);
  background-color: var(--primary-background-color);
  position: absolute;
  width: 16%;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
}

.modal-animated .circle__overlay {
  width: 100%;
  height: 100%;
}

.modal-animated .modal__qrcode {
  filter: blur(2px);
}

.modal-animated .modal__logo {
  border: none;
  animation: spin 2.5s var(--easing) infinite;
}

@keyframes spin {
  0% {
    transform: translate3d(-50%, -50%, 0) rotate(0deg);
  }
  50% {
    transform: translate3d(-50%, -50%, 0) rotate(180deg);
  }
  100% {
    transform: translate3d(-50%, -50%, 0) rotate(360deg);
  }
}

.modal__buttons {
  width: 100%;
  flex-direction: column;
  align-items: center;
  margin-top: 14px;
  display: flex;
  text-align: center;
}

.modal:not(.modal--hidden) .modal__button {
  transform: scale(1) translate3d(0, 0, 0);
}

.modal:not(.modal--hidden) .modal__link {
  transform: scale(1) translate3d(0, 0, 0);
}

.modal__button {
  transform: scale(0) translate3d(0, 150px, 0);
  transition: calc(var(--modal-animation-duration) + 50ms) var(--easing);
  transition-property: scale, transform, background-color;
  cursor: pointer;
  padding: 12px;
  font-size: 14px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 6px;
  width: 100%;
}

.modal__button:hover {
  /* darker shade of --primary-color */
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.1),
    rgba(0, 0, 0, 0.1)
  ) var(--primary-color);
}

.modal__button:disabled {
  background-color: var(--disabled-background-color);
  color: var(--disabled-color);
  cursor: not-allowed;
  pointer-events: none;
}

.modal__link {
  transform: scale(0) translate3d(0, 150px, 0);
  transition: calc(var(--modal-animation-duration) + 150ms) var(--easing);
  transition-property: scale, transform;
  font-size: 0.8rem;
  padding: 10px 20px 0;
  color: var(--primary-color);
  width: 100%;
  text-decoration: underline rgba(0, 0, 0, 0);
}

.modal__link:hover {
  text-decoration-color:var(--primary-color);
}

.modal__close-button {
  position: absolute;
  top: -26px;
  right: -26px;
  width: 24px;
  height: 24px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  cursor: pointer;
  transition: background-color var(--modal-animation-duration) var(--easing);
}

.modal__close-button:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

.modal__close-button:before,
.modal__close-button:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.8);
  transform: translate(-50%, -50%) rotate(45deg);
}

.modal__close-button:after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

/* circle ripple */

.circle__overlay{
  overflow: hidden;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  background-color: var(--primary-background-color);
  border-radius: var(--button-border-radius);
  width: 10%;
  height: 10%;
  border: 2px var(--modal-logo-border-color) solid;
  transition: calc(var(--modal-animation-duration) + 200ms) var(--easing);
  transition-property: width, height, opacity;
}

.circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #E0E0E0;
  animation: circle__ripple 2s linear infinite;
}

.circle--medium {
  width: 150px;
  height: 150px;
  animation-duration: 2.5s;
}

.circle--large {
  width: 200px;
  height: 200px;
  animation-duration: 3s;
}

@keyframes circle__ripple {
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
  }
}
